import React from "react";
import "./SubCard.scss";

const SubCard = ({ imgScr, cardTitle, cardCap }) => {
  return (
    <div className="sub-card">
      <img src={imgScr} />
      <h3>{cardTitle}</h3>
      <p>{cardCap}</p>
    </div>
  );
};

export default SubCard;
